import { ANSWER_SELECT, UPDATE_QUESTION, RECEIVE_QUESTIONS, REFRESH_QUESTIONS, TALLY_RESULTS, UPDATE_RESULT, RESTART } from '../actions';
import getQueryParameterByName from '../utils/getQueryParameterByName';
import { tally } from '../utils/array';

const overrideIndexes = getQueryParameterByName('questions');
const questionsToComplete = overrideIndexes ? overrideIndexes.split(',').length : 4;
const overridePersonaId = getQueryParameterByName('persona');
const answers = overridePersonaId ? [overridePersonaId] : [];

export const quiz = (state = { current: 0, prev: null, questions: [], answers, results: { current: null }, pool: [], beauty: [], poolIndex: 0, questionsToComplete }, action) => {// selected will be array or maybe the q/a should be object with answer object?
  switch (action.type) {
    case ANSWER_SELECT:
      const { index } = action;
      return {
        ...state,
        answers: [...state.answers, index]
      }
    case UPDATE_QUESTION:
      const { current, prev } = action;
      return {
        ...state,
        current,
        prev
      }
    case RECEIVE_QUESTIONS:
      const { questions, pool, beauty } = action;
      return {
        ...state,
        questions,
        pool,
        beauty
      }
    case REFRESH_QUESTIONS:
        // logic to shuffle and pluck new questions
        return {
          ...state
        };
    case UPDATE_RESULT: {
        const { result } = action;
        return {
          ...state,
          results: Object.assign(state.results, {
            current: result
          })
        }
      }
    case TALLY_RESULTS: {
      const result = tally(state.answers);
      return {
        ...state,
        results: {
          result, // actual quiz result
          current: result // if user navigates to another archetype
        }
      }
    }
    case RESTART: {
      // maybe shuffle here instead of refresh?
      const { poolIndex } = action;
      return {
        ...state,
        current: 0,
        prev: null,
        answers: [],
        results: {
          current: null
        },
        poolIndex
      }
    }
    default:
      return state
  }
}
